import { useQuery, gql } from '@apollo/client';

export const GET_ALL_PLATFORM_EMAIL_TEMPLATES = gql`
  query getAllEmailTemplate {
    getAllEmailTemplate {
      _id
      subject
    }
  }
`;

export const useGetAllEmailTemplate = () => {
  const { data, loading } = useQuery(GET_ALL_PLATFORM_EMAIL_TEMPLATES, { fetchPolicy: 'cache-and-network' });

  return {
    templates: data?.getAllEmailTemplate || [],
    loading,
  };
};
